import { Content } from "./styles";

export function AccordionContent({ children }) {
  return <Content>{children}</Content>;
}
